module.exports = __webpack_public_path__ + "img/47_20.7b99ce31.png";